import { DictInterface, BaseResponseInterface } from '@interface/public';
import { AxiosAPI } from '@server/_axios';

const apiPath = { // API地址
  license: 'website/api/v1/license/', // 许可证
  download: 'website/api/v1/download/' // 下载
};

export enum LicenseTypeEnum { // 许可证类型
  Free = 'free',
  Paid = 'paid',
  Enterprise = 'enterprise'
}

export enum LicenseNameEnum { // 许可证名称
  Website = 'website',
  AIPilot = 'AIPilot',
  InfraPilot = 'infra-pilot'
}

export const LicenseTypeDict: DictInterface[] = [ // 许可证类型字典
  {
    label: '社区版',
    value: LicenseTypeEnum.Free
  },
  {
    label: '付费版',
    value: LicenseTypeEnum.Paid,
    expand: {
      disabled: true
    }
  },
  {
    label: '企业版',
    value: LicenseTypeEnum.Enterprise,
    expand: {
      disabled: true
    }
  }
];

export const LicenseNameDist: DictInterface[] = [ // 许可证名称字典
                                                  // {
                                                  //   label: 'Website',
                                                  //   value: LicenseNameEnum.Website
                                                  // },
  {
    label: 'AI应用平台',
    value: LicenseNameEnum.AIPilot
  },
  // {
  //   label: 'AI托管平台',
  //   value: LicenseNameEnum.InfraPilot
  // }
];

//----- 获取许可证信息 Start -----//
export interface RequestGetLicenseInfo {
  product_name: LicenseNameEnum; // 产品名称
}

export interface ResponseGetLicenseInfo extends BaseResponseInterface {
  data: {
    rules: { // 规则列表
      product_category: LicenseTypeEnum; // 许可证类型
      member_limit: number; // 成员数量
      app_limit: number; // 应用数量
      expire_month: number; // 有效期（月）
    }[];
  };
}

export async function AxiosGetLicenseInfo(params: RequestGetLicenseInfo): Promise<any> {
  return AxiosAPI({
    url: `${ apiPath.license }rules`,
    params
  });
}

//----- 获取许可证信息 End -----//

//----- 获取许可证列表 Start -----//
export interface RequestGetLicenseList {
}

export interface ResponseGetLicenseList extends BaseResponseInterface {
  data: {
    license: { // 许可证列表
      product_name: LicenseNameEnum; // 产品名称
      product_category: LicenseTypeEnum; // 许可证类型
      product_release_version: string; // Release版本
      member_limit: number; // 成员数量
      app_limit: number; // 应用
      expire_month: number; // 有效期（月）
    }[];
  };
}

export async function AxiosGetLicenseList(params: RequestGetLicenseList): Promise<any> {
  return AxiosAPI({
    url: `${ apiPath.license }list`,
    params
  });
}

//----- 获取许可证列表 End -----//

//----- 申请许可证 Start -----//
export interface RequestApplyLicense extends BaseResponseInterface {
  request_code: string; // 申请码
  applicant: string; // 申请人
  company: string; // 公司
  product_name: LicenseNameEnum; // 产品名称
  product_category: LicenseTypeEnum; // 许可证类型
  product_release_version: string; // Release版本
  member_limit: number; // 成员数量
  app_limit: number; // 应用
  expire_month: number; // 有效期（月）
  extra: string; // 额外信息
}

export interface ResponseApplyLicense extends BaseResponseInterface {
  data: {
    license: string; // 许可证
  };
}

export async function AxiosApplyLicense(data: RequestApplyLicense): Promise<any> {
  return AxiosAPI({
    url: `${ apiPath.license }generate`,
    method: 'post',
    data
  });
}

//----- 申请许可证 End -----//

//----- 获取下载IFP Start -----//
export interface RequestGetDownloadIFP {
  product_name: string; // 产品名称
  product_category: LicenseTypeEnum; // 许可证类型
  product_release_version: string; // Release版本
}

export interface ResponseGetDownloadIFP extends BaseResponseInterface {
  data: string; // 下载链接
}

export async function AxiosGetDownloadIFP(params: RequestGetDownloadIFP): Promise<any> {
  return AxiosAPI({
    url: `${ apiPath.download }address`,
    params
  });
}

//----- 获取下载链接 End -----//